import { z } from 'zod/v4';

export const vehicleGroupStatsSchema = z.object({
  id: z.number(),
  name: z.string(),
  numberOfVehicles: z.number(),
  numberOfRoutingProfiles: z.number(),
  hasConfigurationSettings: z.boolean(),
});

export type VehicleGroupStats = z.infer<typeof vehicleGroupStatsSchema>;
